"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTheme = exports.resetTheme = void 0;
const Common_1 = require("./Common");
function resetTheme(element) {
    element.classList.remove(...Object.values(Common_1.UI_THEME), ...Object.values(Common_1.DHIG_COLOR_VARIANTS), ...Object.values(Common_1.WEAVE_COLOR_VARIANTS), ...Object.values(Common_1.WEAVE_DENSITY_VARIANTS));
    return element;
}
exports.resetTheme = resetTheme;
function setTheme(element, options) {
    var _a, _b, _c;
    resetTheme(element);
    switch (options === null || options === void 0 ? void 0 : options.theme) {
        case "weave":
            element.classList.add(Common_1.UI_THEME.weave);
            if ((_a = options === null || options === void 0 ? void 0 : options.variant) === null || _a === void 0 ? void 0 : _a.color) {
                element.classList.add(Common_1.WEAVE_COLOR_VARIANTS[options.variant.color]);
            }
            if ((_b = options === null || options === void 0 ? void 0 : options.variant) === null || _b === void 0 ? void 0 : _b.density) {
                element.classList.add(Common_1.WEAVE_DENSITY_VARIANTS[options.variant.density]);
            }
            break;
        case "dhig":
        default:
            element.classList.add(Common_1.UI_THEME.dhig);
            if ((_c = options === null || options === void 0 ? void 0 : options.variant) === null || _c === void 0 ? void 0 : _c.color) {
                element.classList.add(Common_1.DHIG_COLOR_VARIANTS[options.variant.color]);
            }
            break;
    }
    return element;
}
exports.setTheme = setTheme;
